<template>
  <div>
    <div>
      <span class="xbed-sub-title">{{topTitle}}</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>活动管理</BreadcrumbItem>
        <BreadcrumbItem>{{topTitle}}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form  @submit.native.prevent="preventSubmit" :rules='editViewRules' ref='editViewForm' class="edit-display">
      <FormItem label='活动ID' prop="id" :label-width="150" v-if="editView.activityId">
        <span>{{editView.activityId}}</span>
      </FormItem>
      <FormItem label='活动状态' :label-width="150" v-if="editView.activityId">
        <Select v-model="editView.state" :disabled="editState" style="width:300px; margin-right: 10px;">
          <Option :value="2">启用</Option>
          <Option :value="3">停用</Option>
        </Select>
        <Button type="primary" @click="changeState">{{changeBtnText}}</Button>
      </FormItem>
      <FormItem v-if="editView.activityId" :label-width="83">
        <Button type="primary" :loading="addLoading" @click="editInfo" style="width:115px;">{{editable ? '保存' : '编辑'}}</Button>                
      </FormItem>
      <FormItem label='活动标题' prop="title" :label-width="150">
        <Input type="text" v-model.trim="editView.title" :disabled="!editable" :maxlength="100" style="width: 600px"></Input>
      </FormItem>
      <FormItem label='对客描述' prop="describes" :label-width="150">
        <Input type="textarea" v-model.trim="editView.describes" :disabled="!editable" :maxlength="2000" :autosize="{minRows:3,maxRows:5}" style="width: 600px"></Input>
      </FormItem>
      <FormItem label='活动时效' :label-width="150">
        <RadioGroup v-model="editView.type">
          <Radio :label="2" :disabled="!editable" style="width: 150px;margin-left:8px;">限时活动</Radio>
          <Radio :label="1" :disabled="!editable">不限时活动</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label='活动有效时间' prop='creatTime' :label-width="150" v-if="editView.type == 2">
        <DatePicker type="daterange" :editable="false" :disabled="!editable" :readonly="!editable" v-model="creatTime" format="yyyy-MM-dd HH:mm" @on-change="changeDate" placeholder="选择活动有效日期" style="width: 300px"></DatePicker>
      </FormItem>
      <FormItem label='业务触发点' prop='activationId' :label-width="150">
        <Select v-model="editView.activationId" :disabled="editView.activityId !== ''" filterable @on-change="selectBusiness" style="width:300px">
          <Option v-for="(item, index) in businessSelect" :value="item.activationId || ''" :key="index">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label='活动奖励' prop='activityRewardId' :label-width="150">
        <Select ref="resetReward" v-model="editView.activityRewardId" :disabled="(editView.activityId == '' && !selBusiness) || !editable" clearable filterable @click.native="clickReward" style="width:300px">
          <Option v-for="item in rewardSelect" :value="item.rewardId" :key="item.rewardId">{{ item.name }}</Option>
        </Select>
      </FormItem>

      <FormItem label='活动参与人数' prop="userUseMaxCount" :label-width="150" class="activity-num-tips">
        <RadioGroup v-model="limitPeople" @on-change="handleUserRadio">
          <Radio :label="0" :disabled="!editable" style="width: 150px;margin-left:8px;">不限</Radio>
          <Radio :label="1" :disabled="!editable || (editView.activityId !== '' && !editActivityInfo.userUseMaxCount)">限制最大人数</Radio>
        </RadioGroup>
        <InputNumber :disabled="!editable || !limitPeople || (!limitPeople && editView.activityId !== '')" type="text" v-model="editView.userUseMaxCount" :min="1" :max="99999999" :step="1" style="width:300px;margin-left:10px;"></InputNumber>&nbsp;&nbsp;人
        <span v-if="editable && editView.activityId !== '' && limitPeople" class="tips-p" style="margin-left: 30px;">更改数量不可小于已参与人数</span>
      </FormItem>

      <FormItem label='每人参与次数' prop="partakeMaxCount" :label-width="150" class="activity-num-tips">
        <RadioGroup v-model="limitTimes" @on-change="handleTimesRadio">
          <Radio :label="0" :disabled="!editable" style="width: 150px;margin-left:8px;">不限</Radio>
          <Radio :label="1" :disabled="!editable || (editView.activityId !== '' && !editActivityInfo.partakeMaxCount)">限制最大次数</Radio>
        </RadioGroup>
        <InputNumber :disabled="!editable || !limitTimes || (!limitTimes && editView.activityId !== '')" type="text" v-model="editView.partakeMaxCount" :min="1" :max="99999999" :step="1" style="width:300px;margin-left:10px;"></InputNumber>&nbsp;&nbsp;次
        <span v-if="editable && editView.activityId !== '' && limitTimes" class="tips-p" style="margin-left: 30px;">更改数量不可小于原设置</span>
      </FormItem>

      <p class="tips-p" v-if="!editView.activationId">设置范围条件需要先设置业务触发点：</p>
      <FormItem label='参与产品' prop="participatingRooms" :label-width="150">
        <span class="ivu-form-item-label" style="width:180px;text-align:left;margin-left:8px;margin-right:30px;">{{prodText}}</span>
        <Button type="primary" :disabled="!editView.activationId || !editable || isBusiness" @click="settingPops('productionSetting')">设置条件</Button>
      </FormItem>
      <FormItem label='参与用户' prop="participatingUsers" :label-width="150">
        <span class="ivu-form-item-label" style="width:180px;text-align:left;margin-left:8px;margin-right:30px;">{{userText}}</span>
        <Button type="primary" :disabled="!editView.activationId || !editable || isBusiness" @click="settingPops('userSetting')">设置条件</Button>
      </FormItem>
      <FormItem label='参与订单' prop="participatingOrders" :label-width="150">
        <span class="ivu-form-item-label" style="width:180px;text-align:left;margin-left:8px;margin-right:30px;">{{orderText}}</span>
        <Button type="primary" :disabled="!editView.activationId || !editable || isBusiness" @click="settingPops('orderSetting')">设置条件</Button>
      </FormItem>
      <FormItem :label-width="83" v-if="!editView.activityId">
        <Button type="primary" :loading="addLoading" @click="saveInfo" style="width:115px;">确认新建</Button>                
      </FormItem>
    </Form>

    <!-- 参与产品弹窗 -->
    <Modal ref="prodModal" v-model="productionSetting" title="参与产品" :loading="true" @on-cancel="cancelModal('resetChain', 'productionForm')" @on-ok="handleProdOk">
      <Form :rules='editViewRules' ref='productionForm' :model="selChainParam">
        <FormItem>
          <RadioGroup v-model="editView.chainLimitType" @on-change="changeProRadio">
            <Radio :label="0" style="width: 150px;">无限制</Radio>
            <Radio :label="2" style="width: 150px;">参与城市</Radio>
            <Radio :label="1">参与门店</Radio>
          </RadioGroup>
        </FormItem>
        <!-- 选择城市 -->
        <FormItem v-if="editView.chainLimitType === 2" prop="selCityId" label='选择城市' :label-width="68">
          <Select ref="resetCity" v-model="selCityParam.selCityId" clearable filterable placeholder="输入下拉选择" @on-change="selectCity" style="width:343px;margin-right: 10px;">
            <Option v-for="(item, index) in allCities" :value="item" :key="index">{{ item }}</Option>
          </Select>
          <Button type="primary" @click="addCities">添加</Button>
        </FormItem>
        <div v-if="editView.chainLimitType === 2" class="sel-tag" style="margin-bottom:32px;">
          <Tag class="tags" v-for="(item, index) in prodLimit.city" :key="index" :name="index" closable @on-close="deleteCity">{{ item }}</Tag>
        </div>
        <!-- 选择门店 -->
        <FormItem prop="selChainId" :label='editView.chainLimitType === 1 ? "选择门店" : "剔除门店"' :label-width="68">
          <Select ref="resetChain" v-model="selChainParam.selChainId" clearable filterable placeholder="id/名称 输入下拉选择" @on-change="selectChain" style="width:343px;margin-right: 10px;">
            <Option v-for="(item, index) in allChains" :value="item.chainId" :key="index">{{ `${item.chainId}_${item.chainName}` }}</Option>
          </Select>
          <Button type="primary" @click="addChains">添加</Button>
        </FormItem>
      </Form>
      <Content>
        <Table :columns="columns" :data="chainParams.selChainsArr" style="width:480px;max-height:281px;overflow-y:auto;"></Table>
        <div style="margin-top: 10px;overflow: hidden">
          <Page 
            size="small"
            show-total
            :total="chainParams.chainCount" 
            :current="chainParams.pageNum" 
            :page-size="5"
            @on-change="changePage"
          >
          </Page>
        </div>
      </Content>
    </Modal>
    <!-- 参与用户弹窗 -->
    <Modal ref="userModal" v-model="userSetting" title="参与用户" :loading="true" @on-cancel="cancelModal('resetTag', 'userForm')" @on-ok="handleUserOk">
      <Form :rules='editViewRules' ref='userForm' :model="selTagParam">
        <FormItem>
          <RadioGroup v-model="editView.userTagLimit">
            <Radio :label="0" style="width: 150px;">无限制</Radio>
            <Radio :label="1">参与用户标签</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="editView.userTagLimit" prop="selTagId" label='选择标签' :label-width="68">
          <Select ref="resetTag" v-model="selTagParam.selTagId" clearable placeholder="请选择" @on-change="selectTag" style="width:343px;margin-right: 10px;">
            <Option v-for="(item, index) in allUserTags" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
          <Button type="primary" @click="addTags">添加</Button>
        </FormItem>
        <div v-if="editView.userTagLimit && editView.userTagIds.length" class="sel-tag">
          <Tag class="tags" v-for="(item, index) in editView.userTagIds" :key="index" :name="index" closable @on-close="deleteTag">{{ item.name}}</Tag>
        </div>
      </Form>
    </Modal>
    <!-- 参与订单弹窗 -->
    <Modal ref="orderModal" v-model="orderSetting" title="参与订单" :loading="true" @on-cancel="cancelOrderModal(limitOrder)" @on-ok="handleOrderOk">
      <Form :rules='editViewRules' ref="orderForm" :model="editView">
        <FormItem>
          <RadioGroup v-model="editView.orderLimitType" @on-change="changeOrderRadio">
            <Radio :label="0" style="width: 150px;">无限制</Radio>
            <Radio :label="1" style="width: 150px;">参与订单类型</Radio>
            <Radio :label="2">参与入住房晚</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="editView.orderLimitType === 1" prop="orderType" label='选择类型' :label-width="80">
          <Select v-model="orderLimit.orderType" multiple placeholder="请选择(可多选)" style="width:352px;">
            <Option v-for="(item, index) in allOrderType" :value="item.id" :key="index">{{ item.value }}</Option>
          </Select>
        </FormItem>
        <div v-show="editView.orderLimitType === 2">
          <FormItem prop="joinDate" label='可用房晚范围' :label-width="108">
            <DatePicker type="daterange" :editable="false" v-model="orderLimit.joinDate" @on-change="changeJoinDate" format="yyyy-MM-dd" placeholder="请选择可用的房晚日期" style="width: 312px"></DatePicker>
          </FormItem>
          <FormItem prop="week" label='适用星期' :label-width="108">
            <CheckboxGroup v-model="orderLimit.week">
                <Checkbox label="1">一</Checkbox>
                <Checkbox label="2">二</Checkbox>
                <Checkbox label="3">三</Checkbox>
                <Checkbox label="4">四</Checkbox>
                <Checkbox label="5">五</Checkbox>
                <Checkbox label="6">六</Checkbox>
                <Checkbox label="0">日</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label='不参与房晚' :label-width="108" style="margin-bottom:10px;">
            <Button @click="addNoJoinRoom" style="width:115px;">+添加设置</Button>   
          </FormItem>
          <FormItem :label-width="108">
            <div v-for="(item, index) in orderLimit.noJoinDate" :key="index" style="position:relative; margin-bottom: 10px;">
              <DatePicker type="daterange" :editable="false" :clearable="false" v-model="item.date" @on-change="changeNoJoinDate(index)" format="yyyy-MM-dd" placeholder="单选日期/日期段" style="width: 312px"></DatePicker>
              <Icon type="ios-close" @click="deleteDate(index)" size="25" style="margin-left: 5px;position: absolute;top: 5px; color: red; cursor: pointer;"></Icon>
            </div>
          </FormItem>
        </div>
      </Form>
    </Modal>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "../../utils";
import {numRegExp, blankRegExp} from "@/utils/regular"
import Moment from "moment";
export default {
 created() {
    this.editView.activityId = localStorage.getItem("actityId") || ''
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.userId = Utils.findFromLocalStorage( "vue-userid" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
    
    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
      // 'Right': this.token,
      // 'group': 'dev' // 本地请求才需要加该参数
    }
	},
  data () {
    const validateAtity = {
      title:(rule,value,callback) =>{
        if (!this.editView.title) {
          callback(new Error('活动标题不能为空并且小于255个字节'))
        }else{
          if (blankRegExp.test(this.editView.title)) {
            callback(new Error('活动标题不可使用空格'))
          }else{
            callback()
          }
        }
      },
      userUseMaxCount:(rule,value,callback) =>{
        if (this.limitPeople && !numRegExp.test(this.editView.userUseMaxCount)) {
          callback(new Error('请输入1-99999999的正整数'))
        }else{
          callback()
        }
      },
      partakeMaxCount:(rule,value,callback) =>{
        if (this.limitTimes && !numRegExp.test(this.editView.partakeMaxCount)) {
          callback(new Error('请输入1-99999999的正整数'))
        }else{
          callback()
        }
      },
      activationId:(rule,value,callback) =>{
        if (!this.editView.activationId) {
          callback(new Error('请选择业务触发点'))
        }else{
          callback()
        }
      },
      activityRewardId:(rule,value,callback) =>{
        if (!this.editView.activityRewardId) {
          if (!this.selBusiness) {
            callback(new Error('请先设置业务触发点'))
          } else {
            callback(new Error('请选择活动奖励'))
          }
        }else{
          callback()
        }
      },
      describes:(rule,value,callback) =>{
        if (!this.editView.describes) {
          callback(new Error('活动描述不能为空'))
        }else{
          callback()
        }
      },
      creatTime:(rule,value,callback) =>{
        if (this.editView.type === 2 && this.creatTime && !this.creatTime[0]) {
          callback(new Error('请选择活动有效时间'))
        }else{
          callback()
        }
      },
      selChainId: (rule,value,callback) =>{
        if (this.editView.chainLimitType && this.clickAddChain && !this.selChainParam.selChainId && !this.prodLimit.chains.length) {
          callback(new Error('请选择门店'))
        } else {
          if (this.clickAddChain && this.prodLimit.chains.length) {
            for (let value of this.prodLimit.chains) {
              if (value.chainId === this.selChainOption.chainId) {
                callback(new Error('该门店已添加，请重新选择'))
                return
              }
            }
          }
          callback()
        }
      },
      selCityId: (rule,value,callback) => {
        if (this.clickAddCity && !this.selCityParam.selCityId && !this.prodLimit.city.length) {
          callback(new Error('请选择城市'))
        } else {
          if (this.clickAddCity && this.prodLimit.city.length) {
            for (let value of this.prodLimit.city) {
              if (value === this.selCityParam.selCityId) {
                callback(new Error('该城市已添加，请重新选择'))
                return
              }
            }
          }
          callback()
        }
      },
      selTagId: (rule,value,callback) =>{
        if (!this.selTagParam.selTagId) {
          callback(new Error('请选择标签'))
        }else{
          if (this.editView.userTagIds.length) {
            for (let value of this.editView.userTagIds) {
              if (value.id === this.selTagParam.selTagId) {
                callback(new Error('该标签已添加，请重新选择'))
                return
              }
            }
          }
          callback()
        }
      },
      orderType: (rule,value,callback) =>{
        if (this.editView.orderLimitType === 1 && !this.orderLimit.orderType.length) {
          callback(new Error('请选择订单类型'))
        }else{
          callback()
        }
      },
      joinDate: (rule,value,callback) =>{
        if (this.editView.orderLimitType === 2 && this.orderLimit.joinDate && !this.orderLimit.joinDate[0]) {
          callback(new Error('请选择可用的房晚日期'))
        }else{
          callback()
        }
      },
      week: (rule,value,callback) =>{
        if (this.editView.orderLimitType === 2 && !this.orderLimit.week.length) {
          callback(new Error('至少勾选一个'))
        }else{
          callback()
        }
      },
    }

    return {
      businessSelect: [],
      rewardSelect: [],
      editView: {
        activityId: '', // 活动id(新增的时候不用传)
        type: 2, // 活动类型 1 不限时间活动 2 时间范围内有限的活动
        title: '', // 活动标题
        describes: '', // 对客描述
        beginDatetime: '', // 活动开始时间(不传则表示不限时)
        endDatetime: '', // 活动结束时间(不传则表示不限时)
        activationId: '', // 业务触发点id
        activityRewardId: '', // 活动奖励id
        userUseMaxCount: null, // 最大参与人数,0表示不限制
        partakeMaxCount: null, // 最大参与次数,0表示不限制
        chainIds: '', // 参与门店id,多个逗号分割
        excludeChainIds: '', // 剔除门店id,多个逗号分割
        cityNames: '', // 参与城市名字，多个城市逗号分割
        chainLimitType: 0, // 0表示不限制,1表示限制门店2表示限制城市
        orderLimitType: 0, // 0表示不限制,1表示限制订单2表示限制入住房晚
        roomNightLimitDay: '', // 不参与房晚时间段，多个时间段逗号分割 格式: 开始时间&结束时间,开始时间&结束时间 2019-01-01&2019-01-05,2019-02-01&2019-02-05
        roomNightBegin: '', // 房晚限制开始时间
        roomNightEnd: '', // 房晚限制结束时间
        roomNightLimitWeek: '', // 房晚适用星期,比如roomNightLimitWeek=1,2 ；表示只有星期一、星期二能够适用
        rentTypeCondition: '', // 租房类型限制:0无限制1短租2长租3钟点房.(多选逗号分隔)
        userTagLimit: 0, // 0表示不限制用户标签,1表示限制同时userTagIds不为空
        userTagIds: '', // 用户标签id,逗号分隔
      },
      editViewRules: {
        title: [{ required: true, validator: validateAtity.title, trigger: 'blur' }],
        userUseMaxCount: [{ required:true, validator:validateAtity.userUseMaxCount, trigger:'blur' }],
        partakeMaxCount: [{ required:true, validator:validateAtity.partakeMaxCount, trigger:'blur'}],
        activationId: [{ required:true, validator:validateAtity.activationId, trigger:'change'}],
        activityRewardId: [{ required:true, validator:validateAtity.activityRewardId, trigger:'change'}],
        describes: [{ required:true, validator:validateAtity.describes, trigger:'blur'}],
        creatTime: [{ required:true, validator:validateAtity.creatTime, trigger:'change'}],
        selChainId: [{ validator:validateAtity.selChainId, trigger:'change'}],
        selCityId: [{ validator:validateAtity.selCityId, trigger:'change'}],
        selTagId: [{ validator:validateAtity.selTagId, trigger:'change'}],
        orderType: [{ required:true, validator:validateAtity.orderType, trigger:'change'}],
        joinDate: [{ required:true, validator:validateAtity.joinDate, trigger:'change'}],
        week: [{ required:true, validator:validateAtity.week}],
      },
      productionSetting: false, // 活动产品限制弹窗
      userSetting: false, // 活动用户限制弹窗
      orderSetting: false, // 订单限制弹窗
      columns: [
        {
          title: 'id',
          key: 'chainId',
          align: "center",
          width: 80
        },
        {
          title: '门店名',
          key: 'chainName',
          align: "center",
          width: 180
        },
        {
          title: '省市区',
          align: "center",
          width: 140,
          render: (h, params) => {
            return h('span', {}, `${params.row.province} ${params.row.city} ${params.row.district}`)
          }
        },
        {
          title: '操作',
          align: "center",
          width: 78,
          render: (h, params) => {
            return h('span',{
              style: {
                color: '#2d8cf0',
                cursor: 'pointer'
              },
              on:{
                click:()=>{
                  this.removeChain(params.row.chainId)
                }
              }
            }, '删除')
          }
        },
      ],
      chainParams: {
        chainCount: 0,
        pageNum: 1,
        selChainsArr: []
      },
      allChains: [], // 所有的门店数据
      allCities: [], // 所有城市数据
      allUserTags: [], // 所有用户标签
      allOrderType: [ // 所有订单类型
        {
          id: '1',
          value: '日租'
        },
        {
          id: '2',
          value: '长租'
        },
        {
          id: '3',
          value: '钟点房'
        }
      ],
      selChainParam: {
        selChainId: ''
      },
      selCityParam: {
        selCityId: ''
      },
      selTagParam: {
        selTagId: ''
      },
      selChainOption: {},
      selTagOption: {},
      selCities: {},
      limitPeople: 0, //活动参与人数
      limitTimes: 0, //每人参与次数
      limitOrder: 0, // 订单限制
      topTitle: '新增活动',
      prodText: '无限制',
      userText: '无限制',
      orderText: '无限制',

      // 活动管理二期优化 - 0115
      // state: -1, // 活动状态
      changeBtnText: '更改状态',
      editState: true,
      selBusiness: false, // 是否已选择业务触发点
      creatTime:[], // 有效日期
      editable: true,
      addLoading: false, // 新增/编辑按钮
      isBusiness: false, // 预定专用
      editActivityInfo: {
        userUseMaxCount: 1,
        partakeMaxCount: 1
      },
      prodLimit: {   // 参与产品设置
        type: '', // 已选择的类型
        city: [], // 参与城市
        chains: [] // 剔除/选择门店
      },
      orderLimit: {   // 参与订单设置
        type: '', // 已选择的类型
        orderType: [], // 订单类型
        joinDate: [], // 参与时间
        week: ['0','1','2','3','4','5','6'],
        noJoinDate: []
      },
    }
  },
  async mounted() {
    this.$Notice.config( {
			top: 200
		} );

    if (this.editView.activityId) {
      this.topTitle = '活动详情'
      this.editable = false
      this.editActivity()
    } else {
      localStorage.removeItem("activityProd")
      localStorage.removeItem("userTagIds")
      localStorage.removeItem("activityOrder")
    }

    this.businessData()
    this.chainPage()
    this.getUserTags()
  },
  methods: {
    // 设置条件弹窗
    settingPops (type) {
      this[type] = true
      if (type === 'productionSetting') {
        let activityProd = JSON.parse(localStorage.getItem("activityProd"))
        if (activityProd) {
          this.editView.chainLimitType = activityProd.type
          this.prodLimit = activityProd
          if (activityProd.chains.length > 0) this.chainParams.chainCount = activityProd.chains.length
        } else {
          this.chainParams.chainCount = 0
        }
        this.chainParams.pageNum = 1
        if (this.allChains && !this.allChains.length) this.getChainData()
        if (this.allCities && !this.allCities.length) this.getCityData()
        this.chainPage()
      }
      if (type === 'userSetting') {
        let userTagIds = JSON.parse(localStorage.getItem("userTagIds"))
        if (userTagIds && userTagIds.length > 0) {
          this.editView.userTagLimit = 1
          this.editView.userTagIds = userTagIds
        } else {
          this.editView.userTagLimit = 0
          this.editView.userTagIds = []
        }
      }
      if (type === 'orderSetting') {
        let activityOrder = JSON.parse(localStorage.getItem("activityOrder"))
        if (activityOrder) {
          this.editView.orderLimitType = activityOrder.type
          this.orderLimit = activityOrder
        } else {
          this.editView.orderLimitType = 0
        }
      }
    },

    // 活动详情
    async editActivity(){
      let resp = (await API.omsAPI[this.env].clientServer.getActivityDetail(this.editView.activityId, this.protHeaders)).data;
      if ( resp.retCode ) {
        this.$Notice.error({
          title: '获取页面数据失败',
          desc: resp.msg
        })
        return
      }

      Object.assign(this.editView, resp);
      this.editView.chainListDOList = ''
      this.editView.userTagList = ''
      this.editActivityInfo = Object.assign(this.editActivityInfo, resp);
      if (resp.type === 2) this.creatTime = [Moment(resp.beginDatetime).format( 'YYYY-MM-DD HH:mm'),Moment(resp.endDatetime).format( 'YYYY-MM-DD 23:59')]
      if (resp.userUseMaxCount) {
        this.limitPeople = 1
      } else {
        this.editView.userUseMaxCount = null
      }
      if (resp.partakeMaxCount) {
        this.limitTimes = 1
      } else {
        this.editView.partakeMaxCount = null
      }

      // 选择的业务触发点是否预定专用
      this.businessSelect.map(item => {
        if (resp.activationId === item.activationId && item.businessType === 2) {
          this.isBusiness = true
        }
      })
      console.log(this.isBusiness)
      this.rewardData(this.isBusiness)
      if (this.isBusiness) {
        localStorage.removeItem("activityProd")
        localStorage.removeItem("userTagIds")
        localStorage.removeItem("activityOrder")
        return
      }

      this.prodText = ['无限制', '门店', '城市', '城市'][resp.chainLimitType]
      this.orderText = ['无限制', '订单类型', '入住房晚'][resp.orderLimitType]

      // 参与产品
      if (resp.chainLimitType || (resp.excludeChainList && resp.excludeChainList.length)) {
        this.prodLimit.type = resp.chainLimitType
        // 门店
        if (resp.chainListDOList.length) { 
          this.prodLimit.chains = resp.chainListDOList
          this.chainParams.chainCount = resp.chainListDOList.length
        } else if (resp.excludeChainList.length) {
          this.prodLimit.chains = resp.excludeChainList
          this.chainParams.chainCount = resp.excludeChainList.length
        } else {
          this.prodLimit.chains = []
          this.chainParams.chainCount = 0
        }
        this.chainPage()

        // 城市
        this.prodLimit.city = resp.cityNames ? resp.cityNames.split(',') : []
        if (resp.chainLimitType === 0 && this.prodLimit.chains.length) this.prodText = '无限制（剔除部分门店）'
        if (resp.chainLimitType === 2 && this.prodLimit.chains.length) this.prodText = '城市（剔除部分门店）'
        localStorage.setItem('activityProd', JSON.stringify(this.prodLimit))

      } else {
        localStorage.removeItem("activityProd")
      }

      // 参与用户
      if (resp.userTagLimit) {
        this.editView.userTagLimit = resp.userTagLimit
        this.userText = '用户标签'
        localStorage.setItem('userTagIds', JSON.stringify(resp.userTagList))
      } else {
        localStorage.removeItem("userTagIds")
      }

      // 参与订单
      if (resp.orderLimitType) {
        this.orderLimit.type = resp.orderLimitType

        // 订单类型
        if (resp.orderLimitType === 1) {
          this.orderLimit.orderType = resp.rentTypeCondition.split(',')
        }

        // 入住房晚
        if (resp.orderLimitType === 2) {
          this.orderLimit.joinDate = [Moment(resp.roomNightBegin).format( 'YYYY-MM-DD'), Moment(resp.roomNightEnd).format( 'YYYY-MM-DD'),]
          this.orderLimit.week = resp.roomNightLimitWeek && resp.roomNightLimitWeek.split(',')
          this.orderLimit.noJoinDate = []
          if (resp.roomNightLimitDay) {
            let noJoinArr = resp.roomNightLimitDay.split(',')
            noJoinArr.map((item, index) => {
              let noJoin = {}
              let date = item.split('&')
              noJoin.count = index
              noJoin.date = [Moment(date[0]).format( 'YYYY-MM-DD'), Moment(date[1]).format( 'YYYY-MM-DD')]
              this.orderLimit.noJoinDate.push(noJoin)
            })
          }
        }

        localStorage.setItem('activityOrder', JSON.stringify(this.orderLimit))
      } else {
        localStorage.removeItem("activityOrder")
      }
    },

    // 确定新增/保存编辑
    async  saveInfo(){
      if ( !Utils.hasPermission( 'acticity_edit' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      // 表单验证
      if(!this.handleValidator('editViewForm')) return

      let params = this.editView
      params.userId = this.userId
      params.beginDatetime = params.type === 2 ? Moment(this.creatTime[0]).format( 'YYYY-MM-DD HH:mm:ss') : ''
      params.endDatetime = params.type === 2 ? Moment(this.creatTime[1]).format( 'YYYY-MM-DD 23:59:59') : ''
      if (!this.limitPeople) params.userUseMaxCount = 0
      if (!this.limitTimes) params.partakeMaxCount = 0   
      if (params.activityId) {
        params.showBlueClient = '' 
        params.bearParty = '' 
      }

      // 拼接产品限制参数
      let prodLimit = JSON.parse(localStorage.getItem("activityProd"))
      if (prodLimit) {
        if (prodLimit.city.length) {
          params.cityNames = prodLimit.city.join(',')
        }
        if (prodLimit.chains.length){
          let chainsArr = []
          prodLimit.chains.map(item => {
            chainsArr.push(item.chainId)
          })
          if (params.chainLimitType === 1) {
            params.chainIds = chainsArr.join(',')
          } else {
            params.excludeChainIds = chainsArr.join(',')
          }
        }
      } else {
        params.cityNames = ''
        params.chainIds = ''
        params.excludeChainIds = ''
      }

      // 拼接用户限制参数
      if (params.userTagLimit) {
        let userTagIds = JSON.parse(localStorage.getItem("userTagIds"))
        if (userTagIds && userTagIds.length) {
          let tagsIdArr = []
          userTagIds.map(item => {
            tagsIdArr.push(item.id)
          })
          params.userTagIds = tagsIdArr.join(',')
        }
      } else {
        params.userTagIds = ''
      }

      // 拼接订单限制参数
      if (params.orderLimitType) {
        let orderLimit = JSON.parse(localStorage.getItem("activityOrder"))
        if (orderLimit && params.orderLimitType === 1) {
          params.rentTypeCondition = orderLimit.orderType.join(',')

        } else {
          params.roomNightBegin = Moment(orderLimit.joinDate[0]).format( 'YYYY-MM-DD')
          params.roomNightEnd = Moment(orderLimit.joinDate[1]).format( 'YYYY-MM-DD')
          params.roomNightLimitWeek = orderLimit.week.join(',')
          if (orderLimit.noJoinDate.length > 0) {
            let noJoinDay = []
            orderLimit.noJoinDate.map(item => {
              noJoinDay.push(`${Moment(item.date[0]).format( 'YYYY-MM-DD')}&${Moment(item.date[1]).format( 'YYYY-MM-DD')}`)
            })
            params.roomNightLimitDay = noJoinDay.join(',')
          }else{
            params.roomNightLimitDay = ''
          }
        }
        
      } else {
        params.rentTypeCondition = ''
        params.roomNightBegin = ''
        params.roomNightEnd = ''
        params.roomNightLimitWeek = ''
        params.roomNightLimitDay = ''
      }

      // 过滤空字段
      params = Object.keys(params).reduce(function(c, k) {
        if (params[k] || params[k] === 0) {
          c[k] = params[k]
        }
        return c
      }, {})

      try {
        let resp
        this.addLoading = true
        if (params.activityId) {
          resp = (await API.omsAPI[this.env].clientServer.editActivity(params, this.protHeaders)).data;
        } else {
          resp = (await API.omsAPI[this.env].clientServer.addActivity(params, this.protHeaders)).data;
        }
        this.addLoading = false
        
        if ( resp.retCode ) {
          this.$Notice.error({
            title: params.activityId ? '活动编辑失败' : '活动新增失败',
            desc: resp.msg
          })
          if (!this.limitPeople) this.editView.userUseMaxCount = null
          if (!this.limitTimes) this.editView.partakeMaxCount = null
          return
        }
        this.$Notice.success({
          title: params.activityId ? '活动编辑成功' : '活动新增成功',
        })
        if (!params.activityId) this.topTitle = '活动详情'
        this.editView.activityId = resp.activityId
        localStorage.setItem("actityId", resp.activityId)
        this.editable = false
        this.editActivity()
      } catch (e) {
        this.addLoading = false
        this.$Notice.error({
          title: '服务器出错，请稍后再试'
        })
      }
    },

    // 业务触发点数据
    async businessData(){
      let resp = (await API.omsAPI[this.env].clientServer.getActivation({}, this.protHeaders)).data;
      this.businessSelect = resp
    },

    // 活动奖励
    async rewardData(type){
      let param = {
        page: 1,
        size: 10000
      }
      if (type) param["businessType"] = 2
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getActivityReward(param, this.protHeaders)).data;
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取活动奖励数据异常',
            desc: resp.msg
          })
          return
        }
        this.rewardSelect = resp.content
        // if (this.editView.activityId) this.editActivity()
      } catch (e) {
        this.$Notice.error({
          title: '获取活动奖励数据异常'
        })
      }
    },

    // 表单验证
    handleValidator(formName) {
      let validatorResult = false
      this.$refs[formName].validate((valid) => {
        validatorResult = valid
      })
      return validatorResult
    },

    /************   设置活动产品限制 begin   ***************/
    // 获取所有门店数据
    async getChainData () {
      const resp = (await API.omsAPI[this.env].cleaner.queryChainListForCleanOrder(this.token)).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "查询门店列表失败",
          desc: resp.msg
        });
        return
      }
      this.allChains = resp;
      // if (this.editView.id) {
      //   this.editActivity()
      // }
    },
    // 获取所有城市 - 活动二期
    async getCityData () {
      let resp = (await API.omsAPI[this.env].php.queryAllCities()).data.data;
      this.allCities = resp;
    },
    // 已选择的门店分页
    changePage(pageIndex) {
      this.chainParams.pageNum = pageIndex
      this.chainPage()
    },
    // 下拉选择的门店
    selectChain (options) {
      if (!options) return
      this.allChains.map(item => {
        if (item.chainId === options) {
          this.selChainOption = item
          return
        }
      })
    },
    // 门店列表只显示5条数据，分页显示
    chainPage () {
      let currpage = this.chainParams.pageNum
      this.chainParams.selChainsArr = this.prodLimit.chains.slice(Number(currpage * 5 - 5), Number(currpage * 5))
    },
    // 添加选择的门店
    addChains () {
      // 选择框验证
      this.clickAddCity = false
      this.clickAddChain = true
      if(!this.handleValidator('productionForm')) return
      
      this.prodLimit.chains.unshift(this.selChainOption)
      this.chainParams.chainCount++
      this.selChainOption = {}
      this.chainPage()
      this.cancelModal('resetChain', 'productionForm', true)
    },
    // 删除单个门店
    removeChain(chainId) {
      this.prodLimit.chains.map((item, index) => {
        if (item.chainId === chainId) {
          this.prodLimit.chains.splice(index, 1)
        }
      })
      this.chainParams.chainCount--
      if (!Math.ceil(this.chainParams.chainCount % 5)) this.chainParams.pageNum = 1
      this.chainPage()
    },
    /*****  活动二期 - 新增城市选项 begin  */
    // 选择城市
    selectCity(options) {
      if (!options) return
      this.allCities.map(item => {
        if (item === options) {
          this.selCities = item
          return
        }
      })
    },
    // 添加城市
    addCities() {
      this.clickAddChain = false
      this.clickAddCity = true
      if(!this.handleValidator('productionForm')) return

      this.prodLimit.city.unshift(this.selCities)
      this.$refs.resetCity.clearSingleSelect()
      this.$refs.productionForm.resetFields()
    },
    // 删除已添加的城市
    deleteCity(event, index) {
      this.prodLimit.city.splice(index, 1)
    },
    // 选择类型
    changeProRadio(type) {
      this.$refs.resetChain.clearSingleSelect()
      this.$refs.productionForm.resetFields()
      this.clickAddChain = false
      this.clickAddCity = false
      
      let activityProd = JSON.parse(localStorage.getItem('activityProd'))
      if (activityProd && activityProd.type === type) {
        this.prodLimit = activityProd
        this.chainParams.chainCount = activityProd.chains.length ? activityProd.chains.length : 0
      } else {
        this.prodLimit.city = []
        this.prodLimit.chains = []
        this.chainParams.chainCount = 0
      }
      this.chainParams.pageNum = 1
      this.chainPage()
    },
    /*****  活动二期 end  */
    // 确定按钮事件
    handleProdOk() {
      this.$refs.prodModal.buttonLoading = false;
      let editParam = this.editView.chainLimitType
      if (editParam === 1) this.clickAddChain = true
      if (editParam === 2) this.clickAddCity = true
      if(!this.handleValidator('productionForm')) return
      if (editParam === 1 && !this.prodLimit.chains.length)  {
        this.$Notice.error({
          title: '请添加门店'
        })
        return
      }
      if (editParam === 2 && !this.prodLimit.city.length)  {
        this.$Notice.error({
          title: '请添加城市'
        })
        return
      }

      this.productionSetting = false
      if (editParam || this.prodLimit.chains.length) { 
        this.prodLimit.type = editParam
        localStorage.setItem('activityProd', JSON.stringify(this.prodLimit)) 
      } else {
        localStorage.removeItem("activityProd")
      }  
      this.prodText = ['无限制', '门店', '城市', '城市'][editParam]
      if (editParam === 0 && this.prodLimit.chains.length) this.prodText = '无限制（剔除部分门店）'
      if (editParam === 2 && this.prodLimit.chains.length) this.prodText = '城市（剔除部分门店）'
      this.cancelModal('resetChain', 'productionForm')
    },
    /************   设置活动产品限制 end   ***************/

    /************   设置活动用户限制 begin   ***************/
    // 获取所有用户标签
    async getUserTags() {
      let resp = (await API.omsAPI[this.env].clientServer.getUserTag({}, this.protHeaders)).data;
      if (resp.retCode) {
        // 错误警告
        this.$Notice.error({
          title: "获取用户标签失败",
          desc: resp.retsmsg
        });
        return
      }
      this.allUserTags = resp.content
    },
    // 选择用户标签
    selectTag(options) {
      if (!options) return
      this.allUserTags.map(item => {
        if (item.id === options) {
          this.selTagOption = item
          return
        }
      })
    },
    // 添加用户标签
    addTags() {
      // 选择框验证
      if(!this.handleValidator('userForm')) return

      this.editView.userTagIds.unshift(this.selTagOption)
      this.cancelModal('resetTag', 'userForm', true)
    },
    // 删除已添加的用户标签
    deleteTag(event, index) {
      this.editView.userTagIds.splice(index, 1)
    },
    handleUserOk() {
      this.$refs.userModal.buttonLoading = false;
      // 选择框验证
      if(this.editView.userTagLimit && !this.editView.userTagIds.length && !this.handleValidator('userForm')) return
      if(this.editView.userTagLimit && !this.editView.userTagIds.length) {
        this.$Notice.error({
          title: '请添加标签'
        })
        return
      } 
      this.userSetting = false
      if (!this.editView.userTagLimit && this.editView.userTagIds.length > 0) {
        this.editView.userTagIds = []
      }
      localStorage.setItem('userTagIds', JSON.stringify(this.editView.userTagIds))
      this.userText = this.editView.userTagIds.length ? '用户标签' : '无限制'
      this.cancelModal('resetTag', 'userForm')
    },
    /************   设置活动用户限制 end   ***************/

    /************   设置订单限制 begin   ***************/
    handleOrderOk() {
      this.$refs.orderModal.buttonLoading = false;
      if(!this.handleValidator('orderForm')) return
      if (this.editView.orderLimitType) {
        if (this.orderLimit.noJoinDate.length && this.checkNoJoin()) return
        this.orderLimit.type = this.editView.orderLimitType
        localStorage.setItem('activityOrder', JSON.stringify(this.orderLimit))

      } else {
        this.initieOrder()
        localStorage.removeItem("activityOrder")
      }
      this.orderSetting = false
      this.orderText = ['无限制', '订单类型', '入住房晚'][this.editView.orderLimitType]
      this.$refs.orderForm.resetFields()
    },
    // 验证不参与房晚
    checkNoJoin() {
      let resp = false
      for (let i in this.orderLimit.noJoinDate) {
        if (this.orderLimit.noJoinDate[i].date && !this.orderLimit.noJoinDate[i].date[0]) {
          this.$Notice.error({
            title: "不参与房晚日期不能为空"
          });
          resp = true
          break;
        }
      }
      return resp
    },
    cancelOrderModal() {
      let rentArr = JSON.parse(localStorage.getItem('activityOrder'))
      if (this.editView.orderLimitType && !rentArr) {
        this.editView.orderLimitType = 0
        this.initieOrder()
      }
    },
    // 初始化参与订单的值
    initieOrder() {
      Object.assign(this.orderLimit, {
        orderType: [],
        joinDate: [],
        week: ['0','1','2','3','4','5','6'],
        noJoinDate: []
      })
    },
    // 添加不参与房晚设置
    addNoJoinRoom() {
      if (this.orderLimit.joinDate && !this.orderLimit.joinDate[0]) {
        this.$Notice.error({
          title: "请先选择可用的房晚日期"
        })
        return
      }
      if (this.orderLimit.noJoinDate.length === 20) {
        this.$Notice.error({
          title: "最多添加20段"
        })
        return
      }
      this.orderLimit.noJoinDate.push({count: this.orderLimit.noJoinDate.length, date: []})
    },
    // 删除不参与房晚设置
    deleteDate(index) {
      this.orderLimit.noJoinDate.splice(index, 1)
    },
    // 选择类型
    changeOrderRadio(type) {
      this.$refs.orderForm.resetFields()
      
      let activityOrder = JSON.parse(localStorage.getItem('activityOrder'))
      if (activityOrder && activityOrder.type === type) {
        this.orderLimit = activityOrder
      } else {
        this.initieOrder()
      }
    },
    /************   设置订单限制 end   ***************/

    // 关闭 产品/用户 限制弹窗
    cancelModal(resetName, formName, isAdd) {
      if (this.productionSetting || this.userSetting) {
        this.$refs[resetName].clearSingleSelect()
      }
      this.$refs[formName].resetFields()

      if (!isAdd && formName === 'productionForm') {
        this.clickAddChain = false
        this.clickAddCity = false
        let prod = JSON.parse(localStorage.getItem('activityProd'))
        if (this.editView.chainLimitType && !prod) {
          this.prodLimit = {
            city: [], // 参与城市
            chains: [] // 剔除/选择门店
          }
          this.editView.chainLimitType = 0
        }
      } 
      if (!isAdd && formName === 'userForm') {
        let userTagIds = JSON.parse(localStorage.getItem('userTagIds'))
        if (this.editView.userTagLimit && (!userTagIds || userTagIds.length === 0))
          this.editView.userTagLimit = 0
      } 
    },
    // 选择活动起止时间
    changeDate() {
      this.creatTime = this.creatTime[0] ? [
        Moment(this.creatTime[0]).format( 'YYYY-MM-DD HH:mm'),
        Moment(this.creatTime[1]).format( 'YYYY-MM-DD 23:59')
      ] : []
    },
    // handleRadio(value) {
    //   // if (this.limitPeople == 0) this.editView.userUseMaxCount = null
    //   // if (this.limitTimes == 0) this.editView.partakeMaxCount = null
    //   this.editView.userUseMaxCount = this.limitPeople == 0 ? null : this.editActivityInfo.userUseMaxCount
    //   this.editView.partakeMaxCount = this.limitTimes == 0 ? null : this.editActivityInfo.partakeMaxCount
    //   if (value == 0) {
    //     this.$refs.editViewForm.fields.map( e => {
    //       if (e.prop == 'userUseMaxCount' || e.prop == 'partakeMaxCount') {
    //         e.resetField()
    //       }
    //     })
    //   }
    // },
    handleUserRadio(value) {
      this.editView.userUseMaxCount = this.limitPeople == 0 ? null : this.editActivityInfo.userUseMaxCount
      if (value == 0) {
        this.$refs.editViewForm.fields.map( e => {
          if (e.prop == 'userUseMaxCount') {
            e.resetField()
          }
        })
      }
    },
    handleTimesRadio(value) {
      this.editView.partakeMaxCount = this.limitTimes == 0 ? null : this.editActivityInfo.partakeMaxCount
      if (value == 0) {
        this.$refs.editViewForm.fields.map( e => {
          if (e.prop == 'partakeMaxCount') {
            e.resetField()
          }
        })
      }
    },

    /*****  活动二期优化 2020-01-15  ***********/ 
    // 更改状态
    async changeState() {
      if ( !Utils.hasPermission( 'acticity_state' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      if (this.editState) { 
        this.editState = false 
        this.changeBtnText = '保存'
        return
      }
      let params = {
        activityId: this.editView.activityId,
        state: this.editView.state,
        userId: this.userId
      }
      try {
        let resp = (await API.omsAPI[this.env].clientServer.updateState(params, this.protHeaders)).data;
        if (resp.retCode){
          this.$Notice.error( {
            title: "修改活动状态失败",
            desc: resp.msg
          } );
          return
        }
        this.$Notice.success({
          title: "修改活动状态成功",
        });
        this.editState = true
        this.changeBtnText = '更改状态'
      } catch (e) {
        this.$Notice.error({
          title: "服务端内部错误",
        });
      }
    },
    // 编辑按钮
    editInfo() {
      if (!this.editable) {
        this.editable = true
      } else {
        this.saveInfo()
      }
    },

    // 选择业务触发点修改活动奖励选项
    selectBusiness(value) {
      if (!value) return
      this.selBusiness = true
      this.editView.activityRewardId = ''
      this.$refs.resetReward.clearSingleSelect()
      let list = this.businessSelect // rewardSelect
      for (let i in list) {
        if (list[i].activationId === value) {
          if (list[i].businessType === 2) {
            this.isBusiness = true
            this.rewardData(true)
          } else {
            this.rewardData()
            this.isBusiness = false
          }
          break;
        }
      }
    },

    // 需要先选择业务触发点才能选择活动奖励
    clickReward() {
      this.$refs.editViewForm.validateField('activityRewardId');
    },

    // 选择可用房晚时间范围
    changeJoinDate() {
      this.orderLimit.joinDate = this.orderLimit.joinDate[0] ? [
        Moment(this.orderLimit.joinDate[0]).format( 'YYYY-MM-DD'),
        Moment(this.orderLimit.joinDate[1]).format( 'YYYY-MM-DD')
      ] : []
    },

    // 选择不可用房晚时间范围
    changeNoJoinDate(count) {
      this.orderLimit.noJoinDate.map((item, index) => {
        if (count === index) {
          item.date = item.date[0] ? [
            Moment(item.date[0]).format( 'YYYY-MM-DD'),
            Moment(item.date[1]).format( 'YYYY-MM-DD')
          ] : []
        }
      })
    }

  }
}
</script>

<style lang="scss">
.sel-tag {
  border: 1px solid #ddd;
  border-radius: 5px;
  height: 120px;
  overflow-y: auto;
  margin-right: 7px;
  padding-bottom: 10px;
  .tags {
    margin: 10px 0 0 10px;
    height: 26px;
    line-height: 26px;
  }
}
.tips-p {
  color: red;
  margin-bottom: 12px;
  margin-left: 83px;
}
.ivu-select-input[disabled] {
  -webkit-text-fill-color: #000;
}
</style>


// WEBPACK FOOTER //
// src/pages/marketing/activityEditView.vue